import { Component, inject } from '@angular/core';
import { MessageAlertService } from '@services/notifications/message-alert.service';
import { ToastComponent } from '@shared/components/toast/toast.component';
import { SharedModule } from '@shared/modules/shared.module';
import { MessageService } from 'primeng/api';
import { UiCodeBlockComponent } from '../ui-code-block/ui-code-block.component';

@Component({
	selector: 'app-ui-toast',
	imports: [SharedModule, UiCodeBlockComponent, ToastComponent],
	templateUrl: './ui-toast.component.html',
	styleUrl: './ui-toast.component.scss',
})
export class UiToastComponent {
	private messageAlertService = inject(MessageAlertService);
	private messageService = inject(MessageService);

	showSuccess(key: string): void {
		this.messageAlertService.showMessageWithKey(
			'success',
			'Éxito',
			'Operación completada exitosamente. Los cambios se han guardado correctamente en el sistema y ya están disponibles para todos los usuarios.',
			key,
		);
	}

	showInfo(key: string): void {
		this.messageAlertService.showMessageWithKey('info', 'Información', 'Nuevo mensaje', key);
	}

	showWarn(key: string): void {
		this.messageAlertService.showMessageWithKey(
			'warn',
			'Advertencia',
			'Por favor revisa los campos obligatorios',
			key,
		);
	}

	showError(key: string): void {
		this.messageAlertService.showMessageWithKey('error', 'Error', 'No se pudo completar', key);
	}

	showStickyInfo(): void {
		this.messageService.add({
			severity: 'info',
			summary: 'Toast Persistente',
			detail: 'Este toast no se cierra automáticamente',
			key: 'style2-sticky',
			sticky: true,
		});
	}

	showStickyInfoStyle1(): void {
		this.messageService.add({
			severity: 'warn',
			summary: 'Toast Persistente',
			detail: 'Este toast no se cierra automáticamente',
			key: 'style1-sticky',
			sticky: true,
		});
	}

	// Code examples
	successCode = `this.messageAlertService.showMessage('success', 'Éxito', 'Operación completada');`;
	infoCode = `this.messageAlertService.showMessage('info', 'Información', 'Mensaje informativo');`;
	warnCode = `this.messageAlertService.showMessage('warn', 'Advertencia', 'Revisa esto');`;
	errorCode = `this.messageAlertService.showMessage('error', 'Error', 'Ha ocurrido un error');`;
	stickyCode = `this.messageService.add({ 
	severity: 'info', 
	summary: 'Toast Persistente', 
	detail: 'Este toast no se cierra automáticamente',
	sticky: true 
});`;
}
